import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { LoginComponent } from './login/login.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { PublicacionListComponent } from './publicacion-list/publicacion-list.component';
import { EspectaculoListComponent } from './espectaculo-list/espectaculo-list.component';
import { MaratonListComponent } from './maraton-list/maraton-list.component';
import { ActividadListComponent } from './actividad-list/actividad-list.component';
import { ServicioListComponent } from './servicio-list/servicio-list.component';
import { PeliculaListComponent } from './pelicula-list/pelicula-list.component';

const routes: Routes = [
  { path: '', redirectTo: '/login', pathMatch: 'full' },
  { path: 'login', component: LoginComponent },
  { path: 'dashboard', component: DashboardComponent },
  { path: 'publicacion-list', component: PublicacionListComponent },
  { path: 'espectaculo-list', component: EspectaculoListComponent },
  { path: 'maraton-list', component: MaratonListComponent },
  { path: 'actividad-list', component: ActividadListComponent },
  { path: 'servicio-list', component: ServicioListComponent },
  { path: 'pelicula-list', component: PeliculaListComponent },

];


@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
